import { Component, OnInit } from '@angular/core';
import { CommonService } from '../services/common.service';
declare var $: any;

var role: any;
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  role = this.commonService.getUserRole();
  constructor(
    private commonService: CommonService,
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit(){
    var bodyHeight = $(".pcoded-main-container").height()
    $("#sidebar").css("height", bodyHeight)
  }

}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/menu/menu.component.ts